import { useId } from 'react';

/**
 * A grid of labelled text inputs used by both card generators (bulk +
 * single-card) for template fields the operator fills in — `form:`
 * fill-at-generation fields and single-card extra fields. The 2-column grid
 * keeps every label the same width so the inputs line up.
 */
export function FormFieldsInput({
  fields,
  values,
  onChange,
  title,
  hint,
}: {
  fields: string[];
  values: Record<string, string>;
  onChange: (name: string, value: string) => void;
  title?: string;
  hint?: string;
}) {
  const baseId = useId();
  return (
    <div className="space-y-2">
      {title && <p className="text-xs font-medium text-ink">{title}</p>}
      {hint && <p className="text-xs text-muted">{hint}</p>}
      <div className="grid grid-cols-2 gap-3">
        {fields.map((name) => (
          <div key={name}>
            <label
              htmlFor={`${baseId}-${name}`}
              className="mono mb-1 block text-xs text-muted"
            >
              {name}
            </label>
            <input
              id={`${baseId}-${name}`}
              type="text"
              value={values[name] ?? ''}
              onChange={(e) => onChange(name, e.target.value)}
              className="w-full px-2 py-1.5 text-xs"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
